import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronDown, ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { PeriscanLogo } from './PeriscanLogo';
import { Magnet } from './animations/Magnet';
const navItems = [{
  label: 'Product',
  href: '#product'
}, {
  label: 'How It Works',
  href: '#workflow'
}, {
  label: 'AI Security',
  href: '#ai-security'
}, {
  label: 'Evidence',
  href: '#evidence'
}, {
  label: 'Pricing',
  href: '#pricing'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Jobs',
  href: '#jobs'
}];
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <>
      {/* Announcement Bar */}
      <div className="fixed top-0 left-0 right-0 z-[60] bg-[#1a8fd4]/10 border-b border-[#1a8fd4]/20 backdrop-blur-md" data-id="element-481">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-2 flex items-center justify-center gap-3 text-xs" data-id="element-482">
          <span className="font-mono text-[10px] text-[#1a8fd4] tracking-widest uppercase" data-id="element-483">
            2026
          </span>
          <span className="text-white/80" data-id="element-484">
            Periscan is being reborn by its original founder. Early access is
            now forming.
          </span>
          <a href="#early-access" className="hidden sm:inline-flex items-center gap-1 text-[#1a8fd4] hover:text-white transition-colors font-medium" data-id="element-485">
            Join the list
            <ArrowRight className="w-3 h-3" data-id="element-486" />
          </a>
        </div>
      </div>

      {/* Main Header */}
      <header className={`fixed top-9 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#050608]/80 backdrop-blur-xl border-b border-white/5' : 'bg-transparent'}`} data-id="element-487">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4 flex items-center justify-between" data-id="element-488">
          {/* Logo — just the radar mark */}
          <a href="#" className="flex items-center z-10" data-id="element-489">
            <PeriscanLogo variant="mark" size={32} markColor="#1a8fd4" className="h-8 w-auto" data-id="element-490" />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1" data-id="element-491">
            {navItems.map(item => <a key={item.label} href={item.href} className="relative text-sm text-white/60 hover:text-white transition-colors px-3 py-2 rounded-md hover:bg-white/5" data-id="element-492">
                {item.label}
              </a>)}
          </nav>

          {/* CTAs */}
          <div className="hidden md:flex items-center gap-2" data-id="element-493">
            <a href="#early-access" className="text-sm text-white/60 hover:text-white transition-colors px-3 py-2" data-id="element-494">
              Get first report
            </a>
            <Magnet strength={0.3} data-id="element-495">
              <a href="#early-access" className="inline-flex items-center gap-1.5 px-4 py-2 bg-white text-black text-sm font-medium rounded-full hover:bg-white/90 transition-colors" data-id="element-496">
                Get Early Access
                <ArrowRight className="w-3.5 h-3.5" data-id="element-497" />
              </a>
            </Magnet>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-white/80 hover:text-white" aria-label="Toggle menu" data-id="element-498">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-499" /> : <Menu className="w-6 h-6" data-id="element-500" />}
          </button>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-501">
          {mobileMenuOpen && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="md:hidden border-t border-white/5 bg-[#050608]/95 backdrop-blur-xl" data-id="element-502">
              <nav className="flex flex-col px-6 py-6 space-y-1" data-id="element-503">
                {navItems.map(item => <a key={item.label} href={item.href} onClick={() => setMobileMenuOpen(false)} className="text-base text-white/80 hover:text-white py-2.5 transition-colors" data-id="element-504">
                    {item.label}
                  </a>)}
                <a href="#early-access" onClick={() => setMobileMenuOpen(false)} className="mt-4 inline-flex items-center justify-center gap-1.5 px-5 py-3 bg-white text-black text-sm font-medium rounded-full" data-id="element-505">
                  Get Early Access
                  <ArrowRight className="w-3.5 h-3.5" data-id="element-506" />
                </a>
              </nav>
            </motion.div>}
        </AnimatePresence>
      </header>
    </>;
}